const PrimaryFunctions = require('./primary-functions');

exports.Types = {
  Sic: 'SIC',
  Naics: 'NAICS'
};

exports.ByName = {
  SicManufacturer: { Id: 1, Name: 'SIC', PrimaryFunction: PrimaryFunctions.ByName.Manufacturer.Id },
  NaicsManufacturer: { Id: 2, Name: 'NAICS', PrimaryFunction: PrimaryFunctions.ByName.Manufacturer.Id },
  SicDistributor: { Id: 3, Name: 'SIC', PrimaryFunction: PrimaryFunctions.ByName.Distributor.Id },
  NaicsDistributor: { Id: 4, Name: 'NAICS', PrimaryFunction: PrimaryFunctions.ByName.Distributor.Id },
  SicServiceProvider: { Id: 5, Name: 'SIC', PrimaryFunction: PrimaryFunctions.ByName.ServiceProvider.Id },
  NaicsServiceProvider: { Id: 6, Name: 'NAICS', PrimaryFunction: PrimaryFunctions.ByName.ServiceProvider.Id },
  SicIntegrated: { Id: 7, Name: 'SIC', PrimaryFunction: PrimaryFunctions.ByName.Integrated.Id },
  NaicsIntegrated: { Id: 8, Name: 'NAICS', PrimaryFunction: PrimaryFunctions.ByName.Integrated.Id },
  SicOther: { Id: 9, Name: 'SIC', PrimaryFunction: PrimaryFunctions.ByName.Other.Id },
  NaicsOther: { Id: 10, Name: 'NAICS', PrimaryFunction: PrimaryFunctions.ByName.Other.Id },
  SicServiceProviderOther: { Id: 11, Name: 'SIC', PrimaryFunction: PrimaryFunctions.ByName.ServiceProviderOther.Id },
  NaicsServiceProviderOther: { Id: 12, Name: 'NAICS', PrimaryFunction: PrimaryFunctions.ByName.ServiceProviderOther.Id },
  SicDistributorOther: { Id: 13, Name: 'SIC', PrimaryFunction: PrimaryFunctions.ByName.DistributorOther.Id },
  NaicsDistributorOther: { Id: 14, Name: 'NAICS', PrimaryFunction: PrimaryFunctions.ByName.DistributorOther.Id },
  SicRetail: { Id: 15, Name: 'SIC', PrimaryFunction: PrimaryFunctions.ByName.Retail.Id },
  NaicsRetail: { Id: 16, Name: 'NAICS', PrimaryFunction: PrimaryFunctions.ByName.Retail.Id },
  SicValueAddedDistributor: { Id: 17, Name: 'SIC', PrimaryFunction: PrimaryFunctions.ByName.ValueAddedDistributor.Id },
  NaicsValueAddedDistributor: { Id: 18, Name: 'NAICS', PrimaryFunction: PrimaryFunctions.ByName.ValueAddedDistributor.Id },
  SicNonValueAddedDistributor: { Id: 19, Name: 'SIC', PrimaryFunction: PrimaryFunctions.ByName.NonValueAddedDistributor.Id },
  NaicsNonValueAddedDistributor: { Id: 20, Name: 'NAICS', PrimaryFunction: PrimaryFunctions.ByName.NonValueAddedDistributor.Id },
};

exports.ById = {
  1: { Id: 1, Name: 'SIC', PrimaryFunction: PrimaryFunctions.ByName.Manufacturer.Id },
  2: { Id: 2, Name: 'NAICS', PrimaryFunction: PrimaryFunctions.ByName.Manufacturer.Id },
  3: { Id: 3, Name: 'SIC', PrimaryFunction: PrimaryFunctions.ByName.Distributor.Id },
  4: { Id: 4, Name: 'NAICS', PrimaryFunction: PrimaryFunctions.ByName.Distributor.Id },
  5: { Id: 5, Name: 'SIC', PrimaryFunction: PrimaryFunctions.ByName.ServiceProvider.Id },
  6: { Id: 6, Name: 'NAICS', PrimaryFunction: PrimaryFunctions.ByName.ServiceProvider.Id },
  7: { Id: 7, Name: 'SIC', PrimaryFunction: PrimaryFunctions.ByName.Integrated.Id },
  8: { Id: 8, Name: 'NAICS', PrimaryFunction: PrimaryFunctions.ByName.Integrated.Id },
  9: { Id: 9, Name: 'SIC', PrimaryFunction: PrimaryFunctions.ByName.Other.Id },
  10: { Id: 10, Name: 'NAICS', PrimaryFunction: PrimaryFunctions.ByName.Other.Id },
  11: { Id: 11, Name: 'SIC', PrimaryFunction: PrimaryFunctions.ByName.ServiceProviderOther.Id },
  12: { Id: 12, Name: 'NAICS', PrimaryFunction: PrimaryFunctions.ByName.ServiceProviderOther.Id },
  13: { Id: 13, Name: 'SIC', PrimaryFunction: PrimaryFunctions.ByName.DistributorOther.Id },
  14: { Id: 14, Name: 'NAICS', PrimaryFunction: PrimaryFunctions.ByName.DistributorOther.Id },
  15: { Id: 15, Name: 'SIC', PrimaryFunction: PrimaryFunctions.ByName.Retail.Id },
  16: { Id: 16, Name: 'NAICS', PrimaryFunction: PrimaryFunctions.ByName.Retail.Id },
  17: { Id: 17, Name: 'SIC', PrimaryFunction: PrimaryFunctions.ByName.ValueAddedDistributor.Id },
  18: { Id: 18, Name: 'NAICS', PrimaryFunction: PrimaryFunctions.ByName.ValueAddedDistributor.Id },
  19: { Id: 19, Name: 'SIC', PrimaryFunction: PrimaryFunctions.ByName.NonValueAddedDistributor.Id },
  20: { Id: 20, Name: 'NAICS', PrimaryFunction: PrimaryFunctions.ByName.NonValueAddedDistributor.Id },
};
